<template>
  <v-main>
      <ConfsList @hangup="onHangup"/>
      <VideoConf ref="ongoingConference"/>
  </v-main>
</template>

<script>
import VideoConf from '@/components/video_conferences'
import ConfsList from '@/components/video_conferences/list'
import { mapActions } from 'vuex'
export default {
  name: 'view-video-conferences',
  components: { VideoConf, ConfsList },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions({
      init: 'videoconfer/init'
    }),
    onHangup (value) {
      if (value) {
        this.$refs.ongoingConference.hangupRoom()
      }
    }
  }
}
</script>

<style scoped>
</style>
